export default "__VITE_ASSET__ff33b129__"